import {prepareElements} from '../modules/ripple';

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('login-form');
    const errorContainer = document.getElementById('login-error-container');

    if(!form) return;

    form.addEventListener('submit', async function(e) {
        e.preventDefault(); // предотвращаем обычный сабмит полностью

        // Собираем данные формы в объект JSON
        const formData = new FormData(form);
        const payload = {};
        formData.forEach((value, key) => payload[key] = value);

        // Очистка предыдущих ошибок
        errorContainer.innerHTML = '';
        prepareElements();
        let $btn = $(form).find('[type=submit]')
        $btn.addClass('btn--load');

        try {
            const response = await fetch('/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (response.ok && data.success) {
                // Редирект на dashboard
                window.location.href = '/';
            } else {
                // Показываем ошибку
                const errorMessage = data.error || 'Ошибка авторизации';
                errorContainer.innerHTML = `
                    <div class="message message--error">
                        <div class="message__inner">${errorMessage}</div>
                    </div>
                `;
            }
        } catch (err) {
            console.error(err);
            errorContainer.innerHTML = `
                <div class="message message--error">
                    <div class="message__inner">Сервер недоступен. Попробуйте позже.</div>
                </div>
            `;
        }
        $btn.removeClass('btn--load');
    });

    // Дополнительно блокируем submit по Enter вне кнопки, чтобы JSON всегда использовался
    form.querySelectorAll('input').forEach(input => {
        input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                form.dispatchEvent(new Event('submit'));
            }
        });
    });
});
